"use strict";
/*
 * Created on 01 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var EntityAttributeByEntityConverter_1 = require("./conversions/EntityAttributeByEntityConverter");

var EntityAttributeByEntityConverterImpl_1 = require("./conversions/EntityAttributeByEntityConverterImpl");

var EntityAttributeConverter_1 = require("./conversions/EntityAttributeConverter");

var EntityAttributeConverterImpl_1 = require("./conversions/EntityAttributeConverterImpl");
/**
 * AttributesAppModule
 *
 * @author JMe
 */


var AttributesAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(AttributesAppModule, _AppModule_1$AppModul);

  function AttributesAppModule() {
    var _this;

    _classCallCheck(this, AttributesAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AttributesAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'attributesAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AttributesAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(EntityAttributeConverter_1.EntityAttributeConverter).to(EntityAttributeConverterImpl_1.EntityAttributeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(EntityAttributeByEntityConverter_1.EntityAttributeByEntityConverter).to(EntityAttributeByEntityConverterImpl_1.EntityAttributeByEntityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return AttributesAppModule;
}(AppModule_1.AppModule);

exports.AttributesAppModule = AttributesAppModule;